export default __webpack_public_path__ + "static/media/iconTrash.3849d686.svg";